<template>
  <div id="id-article-share" :class="{ 'is-app': isFromApp }">
    <div class="article-main">
      <div class="article-title">{{ articleData.title }}</div>
      <div class="article-info">
        <div
          class="article-avatar"
          v-if="articleData.managerImgPublicUrl != ''"
        >
          <!-- todo 头像图片 -->
          <img :src="articleData.managerImgPublicUrl" alt="" />
        </div>
        <!-- 
          transferFrom 转载字段
          managerImgPublicUrl 基金经理头像
          managerName 基金经理名称
          readingQuantity 阅读量
          postDate 发布时间
          一共四种状态：阅读量和发布时间一直会有，主要是以下四种状态的排版
            1.即没有转载也没有基金经理
            2.既有转载也有基金经理
            3.只有转载没有基金经理
            4.只有基金经理没有转载
         -->
        <div>
          <div
            :style="
              articleData.transferFrom == ''
                ? ''
                : ' color:#999;font-weight:normal;font-size: 0.32rem'
            "
            :class="articleData.transferFrom == '' ? '' : 'flx'"
            class="article-name"
            v-if="articleData.managerImgPublicUrl != ''"
          >
            <span
              :style="
                articleData.transferFrom == ''
                  ? 'display:block;margin-bottom:0.02rem'
                  : ''
              "
              class="items-center"
              >{{ articleData.managerName }}</span
            >

            <div class="article-time flx items-center">
              <span class="dian" v-if="articleData.transferFrom != ''">·</span>
              <span
                class="items-center"
                style="font-size: 0.32rem; line-height: 0.43rem"
                >{{ articleData.postDate }}</span
              >
              <span class="dian items-center">·</span>
              <span class="items-center"
                >阅读量&nbsp;{{ articleData.readingQuantity }}</span
              >
            </div>
          </div>
          <!-- <button @click="owxShare">分享文章</button> -->
          <div class="article-time flx">
            <div
              class="article-time flx items-center"
              v-if="articleData.transferFrom != ''"
            >
              转载自：
              <div
                class="zz"
                :style="
                  articleData.managerImgPublicUrl != ''
                    ? 'max-width: 6rem;'
                    : 'max-width: 3.4rem;'
                "
              >
                {{ articleData.transferFrom }}
              </div>
            </div>
            <div
              class="flx items-center"
              v-if="articleData.managerImgPublicUrl == ''"
            >
              <span v-if="articleData.transferFrom != ''" class="dian">·</span>
              <span
                class="items-center"
                style="font-size: 0.32rem; line-height: 0.43rem"
                >{{ articleData.postDate }}</span
              >
              <div class="article-time items-center">
                <span style="margin: 0 0.11rem 0 0.11rem">·</span>
                <span style="font-size: 0.32rem"
                  >阅读量&nbsp;{{ articleData.readingQuantity }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="article-content" v-html="articleData.content"></div>
    </div>
    <DownloadApp />
  </div>
</template>
<script>
import DownloadApp from "../../components/DownloadApp";
// import axios from axios;
import wx from "weixin-js-sdk";
// import Mshare from "m-share";
export default {
  components: {
    DownloadApp,
  },
  name: "",
  data() {
    return {
      articleData: {},
      param: {
        jsapi_ticket: "",
        noncestr: "hjt-activity818",
        url: "",
      },
      wxConfig: {
        debug: true, // 开启调试模式,调用的所有 api 的返回值会在客户端 alert 出来，若要查看传入的参数，可以在 pc 端打开，参数信息会通过 log 打出，仅在 pc 端时才会打印。
        appId: "", // 必填，公众号的唯一标识
        timestamp: "", // 必填，生成签名的时间戳
        nonceStr: "", // 必填，生成签名的随机串
        signature: "", // 必填，签名
        jsApiList: [],
      },
    };
  },
  async created() {
    const fat = true
    const { data } = fat ? await this.axios.get(`https://fat-market.pyamc.com/api/market/manager/queryManagerArticle?articleId=${this.articleId}`) : await this.axios.get(`https://market.pyamc.com/api/market/manager/queryManagerArticle?articleId=${this.articleId}`)
    // const { data } = await this.axios.get(
    //   `https://market.pyamc.com/api/market/manager/queryManagerArticle?articleId=${this.articleId}`
    // );
    // 上报阅读量
    // window.setTimeout(() => {
    //   this.axios.get(
    //     `https://market.pyamc.com/api/market/news/newsReadingQuantity?articleId=${this.articleId}&count=1`
    //   );
    // }, 3000);
    this.getAccessToken();
    console.log("看啊看data数据", data);
    let val = data.data.postDate;
    let d;
    // 做ios时间兼容用“/”替换“-”，去除.0是数据库格式化时间时在时间后边带了毫秒，后台会处理
    let D = val.replace(/\-/g, "/");
    if (val.endsWith(".0")) {
      console.log(D.replace(/\.0/g, ""));
      d = new Date(D.replace(/\.0/g, ""));
    } else {
      d = new Date(D);
    }
    console.log(d);
    // 时间格式化
    let getMin =
      (d.getMinutes() + "").length <= 1
        ? "0" + (d.getMinutes() + "")
        : d.getMinutes() + "";
    let getHou =
      (d.getHours() + "").length <= 1
        ? "0" + (d.getHours() + "")
        : d.getHours() + "";
    let timeDiffHours = getHou + ":" + getMin;
    let timeDiffDay = parseInt(
      (new Date() - new Date(d)) / (1000 * 60 * 60 * 24)
    );

    // 计算今天还是昨天
    let nd = new Date().getDate();
    let nm = new Date().getMonth() + 1;
    let ny = new Date().getFullYear();
    let od = d.getDate();
    let om = d.getMonth() + 1;
    let oy = d.getFullYear();
    // 新的一年
    if (ny - oy == 0) {
      // 新的一月()
      if (nm - om == 0) {
        // 新的一年
        if (nd - od == 0) {
          timeDiffDay = 0; //今天
        } else if (nd - od == 1) {
          timeDiffDay = 1; // 昨天
        } else {
          timeDiffDay = 2; //日期
        }
      } else if (nm - om == 1) {
        // 当前月份减去旧时间
        if (nd == 1) {
          timeDiffDay = 1;
        } else {
          timeDiffDay = 2; //日期
        }
      } else {
        timeDiffDay = 2; //日期
      }
    } else {
      timeDiffDay = 2; // 昨天
    }
    console.log(timeDiffDay);
    let year = d.getFullYear();
    let month =
      (d.getMonth() + 1 + "").length <= 1
        ? "0" + (d.getMonth() + 1 + "")
        : d.getMonth() + 1 + "";
    let day =
      (d.getDate() + "").length <= 1
        ? "0" + (d.getDate() + "")
        : d.getDate() + "";
    let fulldate = year + "-" + month + "-" + day;
    let postDate = "";
    if (timeDiffDay == 0) {
      postDate = timeDiffHours;
    } else if (timeDiffDay == 1) {
      postDate = "昨天" + timeDiffHours;
    } else {
      postDate = fulldate;
    }
    data.data.postDate = postDate;
    this.articleData = data.data;
    console.log(data);
    // Mshare.init(this.getAccessToken());
  },
  mounted() {
    // let AUTH_TOKEN =
    //   "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1aWQiOjIwMTIxMSwibG4iOiIxMzkxMTQwMTQwNCIsInZlciI6MSwibG50IjoibW9iaWxlIiwiaXAiOiIxMjAuMjQ0LjMwLjE1MiIsImx0Ijoic21zIiwibW9iaWxlIjoiMTM5MTE0MDE0MDQiLCJleHAiOjE2NjA3MDIxMjEsImNvbXBsZXRlIjp0cnVlLCJpYXQiOjE2NjAwOTczMjEsImp0aSI6IjNlYmU4IiwiZGlkIjoidWlkMDAwMDEifQ.LktBN3BYMj_74ap2DcX6BsCZPy0_dLZMiQAmdVp9_mQ";
    // this.axios.defaults.headers.common["Authorization"] = AUTH_TOKEN;
    document.title = "鹏扬观点";
  },

  methods: {
    getAccessToken() {
      const data = this.axios.get(
        "https://fat-trade.pyamc.com/api/user/weChat/getTicket",
        []
      );
      data.then((res) => {
        console.log("res====",res)
        let tickt = JSON.parse(JSON.stringify(res)).data;
        if (tickt.code == "00000" && tickt.data != null) {
          this.wxConfig.appId = tickt.data.appId;
          this.param.jsapi_ticket = tickt.data.ticket;
          this.param.noncestr = this.param.noncestr //"hjt-activity818" //Math.random().toString(36).slice(-10);
          this.param.url ="https://fat-promo.pyamc.com/cms-app-html/articlesShare2?articleId=773"
            // location.href.split("cms-app-html/")[0] + "cms-app-html/";
          this.postChatGetTicket();
        }
      });
    },
    postChatGetTicket() {
      let that = this
      let config = this.axios.post(
        "https://fat-trade.pyamc.com/api/user/weChat/signature",
        this.param
      );
      config.then((res) => {
        let wxShare = JSON.parse(JSON.stringify(res)).data;
        console.log(wxShare, "aaaaaaa");
        if (wxShare.code == "00000" && wxShare.data != null) {
          this.wxConfig.timestamp = wxShare.data.timestamp;
          this.wxConfig.signature = wxShare.data.sign;
          this.wxConfig.nonceStr = this.param.noncestr;
          wx.config({
              debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: that.wxConfig.appId,//congig.appId, // 必填，公众号的唯一标识，填自己的！
              timestamp: that.wxConfig.timestamp, // 必填，生成签名的时间戳，刚才接口拿到的数据
              nonceStr: that.wxConfig.nonceStr, // 必填，生成签名的随机串
              signature: that.wxConfig.signature, // 必填，签名，见附录1
              jsApiList:["updateAppMessageShareData", "updateTimelineShareData"],
            });
        }
        console.log("fffffff", this.wxConfig);
         // 分享到朋友圈    onMenuShareAppMessage
         wx.updateAppMessageShareData({
              title: "鹏扬好基通会员日来了！",
              desc: "每月18号将升级为好基通会员日，邀好友领福利。",
              link: "https://fat-promo.pyamc.com/funds-activity/#/ActivityVIP818",
              imgUrl: "https://fat-promo.pyamc.com/funds-activity/img/818poster.ded5df6d.png",
              // success: function() {
              //     Toast("分享成功");
              // },
              // fail: function() {
              //     Toast("分享失败");
              // },
              // cancel: function() {
              //     Toast("取消分享");
              // }
          });
          wx.updateTimelineShareData({
              title: "鹏扬好基通会员日来了！",
              link: "https://fat-promo.pyamc.com/funds-activity/#/ActivityVIP818",
              imgUrl: "https://fat-promo.pyamc.com/funds-activity/img/818poster.ded5df6d.png",
              // success: function() {
              //     Toast("分享成功");
              // },
              // fail: function() {
              //     Toast("分享失败");
              // },
              // cancel: function() {
              //     Toast("取消分享");
              // }
          });
      });
    },
    // 判断是不是好基通自己的 webView
    isHJT() {
      let ua = navigator.userAgent;
      let isPhone = ua.indexOf("iPhone") !== -1;
      console.log("isPhone:", isPhone);
    },
  },
  computed: {
    isFromApp() {
      // return true
      var data = OpenInstall.parseUrlParams();
      // console.log(data);
      return data.source === "APP" || data.source === "app";
    },
    articleId() {
      return this.$route.query.articleId;
    },
  },
};
</script>
<style lang="scss" scoped>
#id-article-share {
  width: 100vw;
  height: 100vh;
  overflow-y: auto;
  padding-top: 1.707rem;
  background-color: #fff;
  //   .zz{
  //     width: 115px;
  //     display: inline-block;overflow: hidden;

  // text-overflow: ellipsis;

  // white-space: nowrap
  // }
  .article-main {
    padding: 0.667rem 0.427rem 0 0.427rem;
    .article-title {
      font-family: PingFangSC-Medium;
      font-weight: 500;
      line-height: 0.8rem;
      font-size: 0.533rem;
      color: #222222;
      // font-weight: bold;
    }
    .article-info {
      margin-top: 0.533rem;
      display: flex;
      align-items: center;
      & > * {
        margin-right: 0.12rem;
      }
      .dian {
        margin: 0 0.11rem 0 0.11rem;
        align-items: center;
      }
      .items-center {
        align-items: center;
        line-height: 0.43rem;
      }
      .article-avatar {
        position: relative;
        width: 0.96rem;
        height: 0.96rem;
        border-radius: 50%;
        img {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
      }
      .article-name {
        font-size: 0.347rem;
        font-weight: bold;
        color: #333333;
        // margin-bottom: 0.05rem;
      }
      .article-time {
        font-family: PingFangSC-Regular;
        font-size: 0.32rem;
        color: #999999;
        font-weight: 400;
        margin-bottom: 0.02rem;
        .zz {
          max-width: 2.05rem;
          color: #333;
          display: inline-block;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
    .article-content {
      overflow-x: hidden;
      font-family: "PingFangSC-Regular", "微软雅黑", sans-serif;
      padding-top: 0.533rem;
      font-size: 0.427rem;
      color: #333333;
      line-height: 0.693rem;
      font-weight: 400;
      margin-bottom: 0.5rem;
    }
  }
  .flx {
    display: flex;
  }
}
</style>




<!-- wx.config({ 
  debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。 
  appId: res.appId, // 必填，公众号的唯一标识 
  timestamp: res.timestamp, // 必填，生成签名的时间戳 
  nonceStr: res.nonceStr, // 必填，生成签名的随机串 
  signature: res.signature,// 必填，签名 
  jsApiList: ["checkJsApi","updateAppMessageShareData","updateTimelineShareData", "onMenuShareTimeline", "onMenuShareAppMessage", "onMenuShareQQ", "onMenuShareQZone"] // 必填，需要使用的JS接口列表 }); 
  wx.ready(function () { 
    // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。 
  wx.checkJsApi({ jsApiList : ["checkJsApi", "updateAppMessageShareData","updateTimelineShareData","onMenuShareTimeline", "onMenuShareAppMessage", "onMenuShareQQ", "onMenuShareQZone"], // 需要检测的JS接口列表，所有JS接口列表见附录2, 
  success : function(res) { 
    // 以键值对的形式返回，可用的api值true，不可用为false 
    // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"} 
    // alert(res.checkResult); 
    // alert(res.errMsg); } 
  }); //自定义“分享给朋友”及“分享到QQ”按钮的分享内容（1.4.0） 
  wx.updateAppMessageShareData({ 
    title:"饿了么红包", // 分享标题 
    desc: "饿了么红包描述", // 分享描述 
    link: currurl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致 
    imgUrl: ${(pic)!}, // 分享图标 
    success: function () { // 设置成功 } }) 
    //自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容（1.4.0） 
    wx.updateTimelineShareData({ 
      title:"饿了么红包", // 分享标题 
      link: currurl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致 
      imgUrl: ${(pic)!}, 
      success: function () { // 设置成功 } 
    }); //朋友圈 
      wx.onMenuShareTimeline({ 
        title:"饿了么红包", // 分享标题 
        link: currurl, // 分享链接 
        imgUrl: "图片地址", 
        success: function (res) { }, 
        cancel: function (res) { }, 
        fail: function (res) { alert(JSON.stringify(res)); } 
      }); //朋友 
        wx.onMenuShareAppMessage({ 
          title:"饿了么红包", // 分享标题 
          desc: "饿了么红包描述", // 分享描述 
          link: currurl, // 分享链接 
          imgUrl: "图片地址", 
          type: '', // 分享类型,music、video或link，不填默认为link 
          dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空 
          success: function () { // 用户确认分享后执行的回调函数 }, 
          cancel: function () { // 用户取消分享后执行的回调函数 } }); 
          //QQ 
          wx.onMenuShareQQ({ 
            title:"饿了么红包", // 分享标题 
            desc: "饿了么红包描述", // 分享描述 
            link: currurl, // 分享链接 
            imgUrl: "图片地址", // 分享图标 
            success: function () { // 用户确认分享后执行的回调函数 }, 
            cancel: function () { // 用户取消分享后执行的回调函数 } }); 
            //QQ空间 
            wx.onMenuShareQZone({ title:"饿了么红包", // 分享标题 desc: ${(describe)!}, // 分享描述 
            link: currurl, // 分享链接 imgUrl: "图片地址", // 分享图标 
            success: function () { // 用户确认分享后执行的回调函数 }, 
            cancel: function () { // 用户取消分享后执行的回调函数 } }); }); 
            wx.error(function (res) { // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。 
            console.log("初始化wx.config失败" + res) })
3.后端获取签名，注意签名的算法，不然就会签名失败啊，怎么算的，看微信附录1-JS-SDK使用权限签名算法 -->


// WEBPACK FOOTER //
// src/views/h5/ArticleShare2.vue